module.exports = "::ng-deep .popover {\n  width: auto !important; }\n\n.mg-btm-20 {\n  margin-bottom: 20px; }\n\n.input-info {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sessions/edit/session-edit.component.scss
// module id = ./src/app/modules/sessions/edit/session-edit.component.scss
// module chunks = main